module.exports = __webpack_public_path__ + "static/media/2-square-available.9e646bb6.svg";